import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function consolidatedType() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated-type/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`consolidated-type/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('consolidated-type/create', data);
    }

    function update(data) {
        return axiosInstance.patch('consolidated-type/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`consolidated-type/delete`, {
            data: {
                id: id
            }
        });
    }
}
